/**
 * NOTE: I'm doing things a bit hacky here.
 * Normally, controls are rendered with the `controls` array, and
 * that state is owned by Demo. The problem here is that I need to
 * run an effect whenever that state changes, to calculate the
 * actual bounding box sizes. And I want to show that after the
 * component.
 *
 * So, instead, I'm owning the state in this component and rendering
 * the controller manually, outside the `controls` array.
 */

import React from 'react';
import { styled } from '@linaria/react';

import SliderControl from '@/components/Controls/SliderControl';

import FlexDemo from './FlexDemo';
import Output from './Output';
import ShrinkItem from './ShrinkItem';
import useScaledBoxes from './useScaledBoxes';

const FIRST_FLEX_BASIS = 300;
const SECOND_FLEX_BASIS = 150;

function ShrinkBasis() {
  const [width, setWidth] = React.useState(600);

  const [shrunkBy, setShrunkBy] = React.useState(0);

  const {
    scale,
    firstItemRef,
    secondItemRef,
    firstBBWidth,
    secondBBWidth,
  } = useScaledBoxes({ dependencies: [width] });

  React.useEffect(() => {
    if (typeof firstBBWidth !== 'number') {
      return;
    }

    setShrunkBy(
      100 - Math.round((firstBBWidth / FIRST_FLEX_BASIS) * 100)
    );
  }, [firstBBWidth]);

  return (
    <FlexDemo
      centered
      initialValues={{
        '--direction': 'row',
      }}
      renderAfter={() => {}}
    >
      {(state) => (
        <>
          <ScaleWrapper
            style={{
              width: 612,
              height: 300 * scale,
              transform: `scale(${scale})`,
            }}
          >
            <Output
              state={state}
              height={300}
              wrapperStyle={{ width: width + 12 }}
            >
              <ShrinkItem
                ref={firstItemRef}
                flexBasis={FIRST_FLEX_BASIS}
                actualSize={firstBBWidth}
                shrunkBy={shrunkBy}
              />
              <ShrinkItem
                ref={secondItemRef}
                flexBasis={SECOND_FLEX_BASIS}
                actualSize={secondBBWidth}
                shrunkBy={shrunkBy}
              />
            </Output>
          </ScaleWrapper>
          <PseudoControlWrapper>
            <SliderControl
              id="containerWidth"
              label="Container width"
              min={300}
              max={600}
              value={width}
              setValue={setWidth}
              handleFocusColor="white"
            />
          </PseudoControlWrapper>
        </>
      )}
    </FlexDemo>
  );
}

const ScaleWrapper = styled.div`
  transform-origin: top center;
`;

const PseudoControlWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  margin-top: 16px;
  margin-left: auto;
  margin-right: auto;
`;

export default ShrinkBasis;
